import React from 'react';
import { FaHeartbeat, FaStethoscope, FaUserMd } from 'react-icons/fa';
import './WhenToConsult.css';

const WhenToConsult = () => {
    return (
        <section id="consult" className="consult-section">
            <div className="consult-container">
                <h2>¿Cuándo consultar a un Médico Clínico?</h2>
                <p className="consult-subtitle">Tu especialista de cabecera para el cuidado integral de la salud del adulto.</p>

                <p className="consult-intro">
                    El médico clínico (o internista) es el especialista en el paciente adulto visto como un todo, no como la suma de sus órganos. Está capacitado para resolver la gran mayoría de los problemas médicos y guiarte tanto en la enfermedad como en la prevención.
                </p>

                <p className="consult-cta">
                    No esperes a sentirte mal para venir a la consulta. Aquí te detallo los momentos clave para agendar una visita:
                </p>

                <div className="consult-grid">
                    <div className="consult-card">
                        <div className="icon-wrapper">
                            <FaHeartbeat className="consult-icon" />
                        </div>
                        <h3>Por Prevención y Control</h3>
                        <p className="card-subtitle">El famoso "Chequeo". La salud se construye cuando "estamos sanos".</p>
                        <ul>
                            <li><strong>Chequeo Anual de Salud:</strong> Revisión general, análisis de laboratorio y estudios acordes a tu edad y antecedentes para detectar problemas antes de que den síntomas.</li>
                            <li><strong>Aptos Físicos:</strong> Evaluaciones para iniciar actividades deportivas de forma segura.</li>
                            <li><strong>Control de Factores de Riesgo:</strong> Si tenés antecedentes familiares de diabetes, hipertensión o problemas cardíacos, el seguimiento clínico es vital.</li>
                        </ul>
                    </div>

                    <div className="consult-card">
                        <div className="icon-wrapper">
                            <FaStethoscope className="consult-icon" />
                        </div>
                        <h3>Cuando tenés síntomas que no entendés</h3>
                        <p className="card-subtitle">A veces el cuerpo avisa, pero no sabemos a qué especialista recurrir.</p>
                        <ul>
                            <li>Cansancio extremo o fatiga persistente sin causa aparente.</li>
                            <li>Cambios de peso inexplicables (aumento o descenso brusco).</li>
                            <li>Dolores persistentes (de cabeza, musculares, abdominales) que no ceden.</li>
                            <li>Fiebre prolongada o sensación de malestar general.</li>
                        </ul>
                    </div>

                    <div className="consult-card">
                        <div className="icon-wrapper">
                            <FaUserMd className="consult-icon" />
                        </div>
                        <h3>Si buscás un cambio real en tu calidad de vida</h3>
                        <p className="card-subtitle">Consultame si tu objetivo es abordar la raíz de los problemas crónicos mediante el cambio de hábitos:</p>
                        <ul>
                            <li>Necesitás orientación médica para mejorar tu alimentación, sueño o manejo del estrés.</li>
                            <li>Buscás un enfoque que no se base únicamente en medicamentos, sino en ver tu salud como un todo.</li>
                            <li>Tenés enfermedades crónicas (Hipertensión, Dislipemia/Colesterol, Diabetes tipo 2) y querés optimizar el manejo a través cambios en tu estilo de vida.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhenToConsult;
